<template>
  <div class="article_list-container" ref="article_list">
    <!-- <app-loading :loaded="loaded"></app-loading> -->
    <mescroll-vue
      ref="mescroll"
      class="view-container"
      :up="mescrollUp"
      :down="mescrollDown"
      @init="mescrollInit"
    >
      <div class="lz-bg-fff isPadding">
        <div class="ul-js-box">
          <article-list :articleData="articleData"></article-list>
        </div>
      </div>
    </mescroll-vue>
  </div>
</template>
<script>
import articleList from "@/components/article/articleList";
import lodash from "lodash";
import Swiper from "@static/js/swiper-4.3.3.min";
import "@static/css/swiper-4.3.3.min.css";
import mscll from "@/api/mescrolls.js"; //工具
import MescrollVue from "mescroll.js/mescroll.vue";
import loading from "@/components/commons/loading";
//当前实例组件
var vm = null;
export default {
  props: ["articletype", "articlecode"],
  data() {
    return {
      pageSize: 20,
      pageNum: 1,
      articleData: [],
      navUlHeight: 0,
      loaded: false
    };
  },
  components: {
    "article-list": articleList,
    "mescroll-vue": MescrollVue,
    "app-loading": loading //加载中
  },
  created() {
    vm = this;
    //下拉刷新初始化
    mscll.init(
      vm,
      { use: false },
      {
        callback: vm.shareArticleAjax,
        auto: false
      }
    );
  },
  beforeDestroy() {
    this.mescroll.setBounce(true);
  },
  methods: {
    /** mescroll 初始化*/
    mescrollInit(mescroll) {
      this.mescroll = mescroll;
      let pageHeight = this.$parent.$refs.pageHeight.clientHeight;
      this.$refs.article_list.style.height = pageHeight - 46 - 45 + "px";
    },
    //文章列表数据请求
    shareArticleAjax(page, mescroll) {
      this.$http({
        url: "/app/articleCategory/api/article/list",
        data: {
          code: this.articlecode, //文章code
          pageSize: page ? page.size : this.pageSize,
          pageNum: page ? page.num : this.pageNum,
          type: this.articletype
        }
      })
        .then(data => {
          setTimeout(() => {
            vm.loaded = true;
          }, 500);
          console.log(data);
          if (vm.pageNum == 1 || page.num == 1) {
            //判断滑动高度是否大于导航到顶部的高度 是的话回到导航顶部位置
            if (vm.mescroll.preScrollY > vm.navUlHeight) {
              vm.mescroll.setScrollTop(vm.navUlHeight);
            }
            //当页数为1时 重置数据
            vm.articleData = data.data.list;
          } else {
            //下拉树数据拼接
            vm.articleData = vm.articleData.concat(data.data.list);
          }
          vm.pageNum++;
          vm.$nextTick(() => {
            vm.mescroll.endSuccess(data.data.list.length);
          });
        })
        .catch(err => {
          setTimeout(() => {
            vm.loaded = true;
          }, 500);
          if (vm.mescroll) vm.mescroll.endSuccess();
        });
    }
  },
  mounted() {
    vm.shareArticleAjax();
  },
  beforeRouteLeave(to, from, next) {
    vm.mescroll.setBounce(true);
    next();
  }
};
</script>